import React, { useEffect, useState } from 'react';
import api from '~/services/api';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Accordion, Card } from 'react-bootstrap';
import { useAccordionToggle } from 'react-bootstrap/AccordionToggle';
import { Redirect } from 'react-router';

import {
  PageContainer,
  Container,
  Content,
  HeaderContent,
  HeaderContainer,
  WrapperInvoices,
  CloseIconContainer,
  CloseIcon,
  PageTitleContainer,
  PageIcon,
  PageTitle,
  FielterContainer,
  FielterButton,
  ContractTitle,
  DivisionItems,
  DesktopContainer,
  MobileContainer,
  DivisionCardHeader,
  WhiteDivision,
  GrayDivision,
  AlignNoVoucher
} from './styles';
import "~/components/styles/Contracts.css";
import SideBar from '~/components/layout/Sidebar';
import Header from '~/components/layout/Header';
import HeaderMobile from '~/components/layout/HeaderOld';
import back from '~/assets/images/arrow.svg';
import contractImg from '~/assets/images/Contratos_e_adendos.svg';
import arrowDown from '~/assets/images/arrow-down.svg';
import arrowUp from '~/assets/images/arrow-up.svg';
import Loading from '~/components/layout/Loading';
import Item from '~/components/pages/Contracts/Item';
import ModalContracts from "~/components/pages/Contracts/Modal";
import OpenChatBot from '~/components/layout/Chatbot';
import { verifyRoles } from '~/utils/functions/verifyRoles';

export default function Contracts() {
  const history = useHistory();
  const economicGroupReducer = useSelector(
    (state) => state.economicGroupReducer
  );
  const roles = useSelector(state => state.rolesReducer.roles);

  const [filterActive, setFilterActive] = useState(
    window.screen.width < 768 ? "" : "CONTRATO"
  );
  const [showModal, setShowModal] = useState(false);
  const [contracts, setContracts] = useState([]);
  const [terms, setTerms] = useState([]);
  const [addendums, setAddendums] = useState([]);
  const [listInView, setListInView] = useState([]);
  const [loading, setLoading] = useState(true);
  const [contractChoosed, setContractChoosed] = useState(null);
  const [indexChoosed, setindexChoosed] = useState(null);
  const [downloadGone, setDownloadGone] = useState(false);

  function activeModal(condition) {
    if (!condition) {
      setShowModal(false);
    } else {
      setShowModal(true);
    }
  }

  function getContracts() {
    setLoading(true);
    window.screen.width < 768 ? setFilterActive("") : setFilterActive("CONTRATO");
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token')
    };

    const parameters = {
      method: 'GET',
      headers: header,
    };

    const url = `/residential/store/v1/stores/${localStorage.getItem(
      "storeId"
    )}/contracts`;

    api.get(url, parameters)
    .then((res) => {
      let termsArray = [];
      let addendumsArray = [];
      let contractsArray = [];
      res.data.map((element) => {
        if(element.contractType === "Termo de Adesão") {
          termsArray.push(element);
        } else if (element.contractType === "Adendo" ||
        element.contractType === "Adendo/Neg.") {
          addendumsArray.push(element);
        } else {
          contractsArray.push(element);
        }
        return ''
      });
      setListInView(contractsArray);
      setAddendums(addendumsArray);
      setTerms(termsArray);
      setContracts(contractsArray);
      setLoading(false);
    })
    .catch((err) => {})
  }

  useEffect(() => {
    getContracts();
  }, [economicGroupReducer.selectedStore]);

  useEffect(() => {
    changeContractInView(filterActive);
  }, [filterActive]);

  function changeContractInView(contractType) {
    if(contractType === "TERMOS") {
      setListInView(terms);
    } else if (contractType === "ADENDOS") {
      setListInView(addendums);
    } else {
      setListInView(contracts);
    }
  }

  function CustomToggle({ children, eventKey, item }) {
    let activeFilter = filterActive
    const decoratedOnClick = useAccordionToggle(eventKey, () => {
      return (
        filterActive === item ?
         setFilterActive("") : setFilterActive(item)
      )
    });

    let itemName =  item === "CONTRATO" ? "Contrato" : (
      item === "TERMOS" ? "Termos de Adesão" : "Adendos"
    );

    return (
      <DivisionCardHeader>
        <span>
          {itemName}
        </span>
        {
          activeFilter === item ? (
            <WhiteDivision onClick={decoratedOnClick} activeItem={true}>
              <img src={arrowUp} alt="Seta para cima" />
            </WhiteDivision>
          ) : (
            <GrayDivision onClick={decoratedOnClick} activeItem={false}>
              <img src={arrowDown} alt="Seta para baixo" />
            </GrayDivision>
          )
        }
      </DivisionCardHeader>
    );
  }

  function dowloadContent(file, contract) {
    const linkSource = `data:application/pdf;base64,${file}`;
    const downloadLink = document.createElement("a");
    const fileName = `${contract.contractType}-${indexChoosed + 1}.pdf`;

    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
    activeModal(false);
  }

  return (
    <PageContainer>
      {verifyRoles(roles, 'CONTRATOS') ? (
        <SideBar menuSelected={'Minha Conta'}>
          <Container>
            <HeaderContainer>
              <Header
                userName={localStorage.getItem('userName')}
                userEmail={localStorage.getItem('userEmail')}
                storeName={localStorage.getItem('storeName')}
                storeDocument={localStorage.getItem('storeDocument')}
              />
            </HeaderContainer>
            <Content>
              <HeaderContent>
                <HeaderMobile />
              </HeaderContent>
              <WrapperInvoices>
                <CloseIconContainer>
                  <CloseIcon>
                    <img
                      src={back}
                      alt="Ícone para voltar"
                      onClick={() => {
                        history.push('/minha-conta');
                      }}
                    />
                  </CloseIcon>
                </CloseIconContainer>

                <DesktopContainer>
                  <PageTitleContainer>
                    <ContractTitle>
                      <PageIcon src={contractImg} />
                      <PageTitle>Contratos e Adendos</PageTitle>
                    </ContractTitle>
                    <FielterContainer>
                      {
                        loading ? null : (
                          <>
                            <FielterButton
                              active={filterActive === "CONTRATO"}
                              onClick={() => setFilterActive("CONTRATO")}
                            >
                              Contratos
                            </FielterButton>
                            <FielterButton
                              active={filterActive === "TERMOS"}
                              onClick={() => setFilterActive("TERMOS")}
                            >
                              Termos de Adesão
                            </FielterButton>
                            <FielterButton
                              active={filterActive === "ADENDOS"}
                              onClick={() => setFilterActive("ADENDOS")}
                            >
                              Adendos
                            </FielterButton>
                          </>
                        )
                      }
                    </FielterContainer>
                  </PageTitleContainer>
                  <ModalContracts
                    contract={contractChoosed}
                    showModal={showModal}
                    activeModal={activeModal}
                    dowloadContent={dowloadContent}
                    index={indexChoosed}
                  />
                  {
                    loading ? <Loading /> : (
                      <>
                        <DivisionItems>
                          {
                            listInView.length < 1 && filterActive !== "" ? (
                              <AlignNoVoucher>
                                <span>Nenhum {
                                  filterActive === "CONTRATO" ? "contrato" : (
                                    filterActive === "TERMOS" ? "termo de adesão" :
                                    "adendo"
                                  )
                                } encontrado</span>
                              </AlignNoVoucher>
                            ) : (
                              <>
                                {
                                  filterActive !== "" ? (
                                    <>
                                    {
                                      listInView.map((contract, index) =>
                                        <Item
                                          key={contract.attachmentId}
                                          index={index}
                                          contract={contract}
                                          showModal={showModal}
                                          activeModal={activeModal}
                                          setContractChoosed={setContractChoosed}
                                          setindexChoosed={setindexChoosed}
                                          downloadGone={downloadGone}
                                          setDownloadGone={setDownloadGone}
                                        />
                                      )
                                    }
                                    </>
                                  ) : null
                                }
                              </>
                            )
                          }
                        </DivisionItems>
                      </>
                    )
                  }
                </DesktopContainer>

                <MobileContainer className="contracts">
                  <PageTitleContainer>
                    <ContractTitle>
                      <PageIcon src={contractImg} />
                      <PageTitle>Contratos e Adendos</PageTitle>
                    </ContractTitle>
                  </PageTitleContainer>
                  {
                    loading ? <Loading /> : (
                      <Accordion className="contract">
                        {
                          ["CONTRATO", "TERMOS", "ADENDOS"].map((item, index) => (
                            <Card>
                              <Card.Header>
                                <CustomToggle
                                  eventKey={index}
                                  item={item}
                                >
                                </CustomToggle>
                              </Card.Header>
                              <Accordion.Collapse
                                className={filterActive === item ? "show" : ""}
                                eventKey={index}
                              >
                                <Card.Body>
                                {
                                  loading ? <Loading margin="10% auto" /> : (
                                    <>
                                      <DivisionItems>
                                        {
                                          listInView.length < 1 && filterActive !== "" ? (
                                            <AlignNoVoucher>
                                              <span>Nenhum {
                                                filterActive === "CONTRATO" ? "contrato" : (
                                                  filterActive === "TERMOS" ? "termo de adesão" :
                                                  "adendo"
                                                )
                                              } encontrado</span>
                                            </AlignNoVoucher>
                                          ) : (
                                            <>
                                              {
                                                filterActive !== "" ? (
                                                  <>
                                                  {
                                                    listInView.map((contract, index) =>
                                                      <Item
                                                        key={contract.attachmentId}
                                                        index={index}
                                                        contract={contract}
                                                        showModal={showModal}
                                                        activeModal={activeModal}
                                                        setContractChoosed={setContractChoosed}
                                                        setindexChoosed={setindexChoosed}
                                                        downloadGone={downloadGone}
                                                        setDownloadGone={setDownloadGone}
                                                      />
                                                    )
                                                  }
                                                  </>
                                                ) : null
                                              }
                                          </>
                                          )
                                        }
                                      </DivisionItems>
                                    </>
                                  )
                                }
                                </Card.Body>
                              </Accordion.Collapse>
                            </Card>
                          ))
                        }
                      </Accordion>
                    )
                  }
                </MobileContainer>
              </WrapperInvoices>
            </Content>
          </Container>
          <OpenChatBot />
        </SideBar>
      ) : (
        <Redirect to="/portal" />
      )}
    </PageContainer>
  );
}
